/**
 * Router-level pending fallback.
 *
 * Every admin route awaits `GET /auth/me` in `beforeLoad` before its component
 * renders; without a `defaultPendingComponent` the app painted a blank white
 * screen (indistinguishable from a crash) until auth resolved. This is the
 * app-shell cold-load state — in-page list fetches have their own skeletons.
 *
 * Deliberately minimal + dependency-free (no auth read, no data) so it can
 * render before the session is known and never itself be a source of error.
 */
export function AdminPending() {
  return (
    <div
      className="flex min-h-screen flex-col items-center justify-center bg-cream"
      data-testid="admin-pending"
      role="status"
      aria-live="polite"
    >
      <div
        aria-hidden
        className="h-8 w-8 animate-spin rounded-full border-2 border-forest/25 border-t-forest"
      />
      <p className="mt-4 font-body text-sm text-ink-muted">Loading…</p>
    </div>
  );
}
